import script from "./ContributePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributePage.vue?vue&type=script&setup=true&lang=js"

import "./ContributePage.vue?vue&type=style&index=0&id=5b6f97da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6f97da"]])

export default __exports__